import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/index'
    }, // 路由重定向，默认显示路由页面
    {
      path: '/index', //主页
      name: 'ProductMain',
      component: resolve => require(['@/components/Product/ProductMain'], resolve),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/sort', //分类
      name: 'Sort',
      component: resolve => require(['@/components/Sort/Sort'], resolve),
      meta: {
        keepAlive: true // 不需要被缓存 
      }
    },
    {
      path: '/shoppingcart', //购物车
      name: 'ShoppingCart',
      component: resolve => require(['@/components/ShoppingCart/ShoppingCart'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/my', //个人中心
      name: 'My',
      component: resolve => require(['@/components/My/My'], resolve),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/receiveraddressmanage', //地址管理
      name: 'ReceiverAddressManage',
      component: resolve => require(['@/components/My/ReceiverAddressManage'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/receiveraddressedit', //地址新增和编辑
      name: 'ReceiverAddressEdit',
      component: resolve => require(['@/components/My/ReceiverAddressEdit'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/sellercompanyinfo', //我的供应商信息
      name: 'SellerCompanyInfo',
      component: resolve => require(['@/components/My/SellerCompanyInfo'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/report', //报表
      name: 'Report',
      component: resolve => require(['@/components/My/Report'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/reportproductbill', //采购商品报表
      name: 'ReportProductBill',
      component: resolve => require(['@/components/My/ReportProductBill'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/reportpaymentbill', //采购付款报表
      name: 'ReportPaymentBill',
      component: resolve => require(['@/components/My/ReportPaymentBill'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/productlistresult', //搜索和分类商品展示页
      name: 'ProductListResult',
      component: resolve => require(['@/components/Product/ProductListResult'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/productdetail', //商品详情
      name: 'ProductDetail',
      component: resolve => require(['@/components/Product/ProductDetail'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/productdetail2',
      name: 'ProductDetail2',
      component: resolve => require(['@/components/Product/ProductDetail2'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/productdetail3',
      name: 'ProductDetail3',
      component: resolve => require(['@/components/Product/ProductDetail3'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/collectionandhistory', //我的收藏和历史
      name: 'CollectionAndHistory',
      component: resolve => require(['@/components/Product/CollectionAndHistory'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/searchpage', //搜索页
      name: 'SearchPage',
      component: resolve => require(['@/components/Product/SearchPage'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/login', //登录
      name: 'Login',
      component: resolve => require(['@/components/User/Login'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/register', //注册
      name: 'Register',
      component: resolve => require(['@/components/User/Register'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/accountmanagement', //账户管理
      name: 'AccountManagement',
      component: resolve => require(['@/components/User/AccountManagement'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/companyinfofinance', //商户发票信息
      name: 'CompanyInfoFinance',
      component: resolve => require(['@/components/User/CompanyInfoFinance'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/companyinfobase', //企业信息
      name: 'CompanyInfoBase',
      component: resolve => require(['@/components/User/CompanyInfoBase'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/wxauthsucceed', //微信授权成功
      name: 'WxAuthSucceed',
      component: resolve => require(['@/components/User/WxAuthSucceed'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/addorder', //下单
      name: 'AddOrder',
      component: resolve => require(['@/components/Order/AddOrder'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/allorder', //我的订单
      name: 'AllOrder',
      component: resolve => require(['@/components/Order/AllOrder'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/orderpurchasedetail', //订单详情
      name: 'OrderPurchaseDetail',
      component: resolve => require(['@/components/Order/OrderPurchaseDetail'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/orderpayment', //支付
      name: 'OrderPayment',
      component: resolve => require(['@/components/Order/OrderPayment'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/orderpaymentwx', //微信支付
      name: 'OrderPaymentWX',
      component: resolve => require(['@/components/Order/OrderPaymentWX'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/goodsreturnrequest', //退货申请
      name: 'GoodsReturnRequest',
      component: resolve => require(['@/components/Order/GoodsReturnRequest'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/goodsreturnpurchasemain', //我的退货
      name: 'GoodsReturnPurchaseMain',
      component: resolve => require(['@/components/Order/GoodsReturnPurchaseMain'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/goodsreturndetail', //退货单详情
      name: 'GoodsReturnDetail',
      component: resolve => require(['@/components/Order/GoodsReturnDetail'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/ordertracking', //物流信息
      name: 'OrderTracking',
      component: resolve => require(['@/components/Order/OrderTracking'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financepaymentmanage', //付款单管理
      name: 'FinancePaymentManage',
      component: resolve => require(['@/components/Finance/FinancePaymentManage'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financepaymentdetail', //付款单详情
      name: 'FinancePaymentDetail',
      component: resolve => require(['@/components/Finance/FinancePaymentDetail'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financesalesrebatemanage', //采购返点管理
      name: 'FinanceSalesRebateManage',
      component: resolve => require(['@/components/Finance/FinanceSalesRebateManage'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financesalesrebatedetail', //采购返点详情
      name: 'FinanceSalesRebateDetail',
      component: resolve => require(['@/components/Finance/FinanceSalesRebateDetail'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financereconciliation', //采购对账
      name: 'FinanceReconciliation',
      component: resolve => require(['@/components/Finance/FinanceReconciliation'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financereconciliationdetail', //采购对账详情
      name: 'FinanceReconciliationDetail',
      component: resolve => require(['@/components/Finance/FinanceReconciliationDetail'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financeadvancemanage', //预付款管理
      name: 'FinanceAdvanceManage',
      component: resolve => require(['@/components/Finance/FinanceAdvanceManage'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financeadvancewithdrawmanage', //预付款提现管理
      name: 'FinanceAdvanceWithdrawManage',
      component: resolve => require(['@/components/Finance/FinanceAdvanceWithdrawManage'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financeadvancewithdrawdetail', //预付款提现详情
      name: 'FinanceAdvanceWithdrawDetail',
      component: resolve => require(['@/components/Finance/FinanceAdvanceWithdrawDetail'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financeadvancewithdrawadd', //新增预付款提现
      name: 'FinanceAdvanceWithdrawAdd',
      component: resolve => require(['@/components/Finance/FinanceAdvanceWithdrawAdd'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/financeadvancerecharge', //预付款充值
      name: 'FinanceAdvanceRecharge',
      component: resolve => require(['@/components/Finance/FinanceAdvanceRecharge'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/dealermessagemain', //消息管理
      name: 'DealerMessageMain',
      component: resolve => require(['@/components/Message/DealerMessageMain'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/dealermessagedetail', //通知详情
      name: 'DealerMessageDetail',
      component: resolve => require(['@/components/Message/DealerMessageDetail'], resolve),
      meta: {
        keepAlive: false // 不需要被缓存
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js